import LoginBox from '../components/sections/Login/LoginBox';

export default function SignIn() {
  return (
    <div>
      <LoginBox />
    </div>
  );
}
